export enum CartErrorModalDatahooks {
  Modal = 'cart-error-modal',
}
